import { t } from "@lingui/core/macro"
import { Typography } from "../../common"
import { RotateToPortrait } from "../../common/atoms/Icons/Chat"
import styles from "./LandscapeModal.module.scss"

type Props = {
    onClose: () => void
}

export function LandscapeModal({ onClose }: Props) {
    const headline = t`Rotate to View Messages`
    const text = t`Please rotate your device to portrait mode to continue.`
    const buttonText = t`Got it`

    const handleConfirm = () => {
        onClose()
    }

    return (
        <div className={styles.container} data-testid="landscape-modal">
            <div className={styles.modal}>
                <div
                    className={styles.imgContainer}
                    data-testid="landscape-icon"
                >
                    <RotateToPortrait />
                </div>
                <Typography
                    className={styles.headline}
                    data-testid="landscape-headline"
                >
                    {headline}
                </Typography>
                <Typography
                    className={styles.text}
                    data-testid="landscape-text"
                >
                    {text}
                </Typography>
                <button
                    className={styles.confirm}
                    onClick={handleConfirm}
                    data-testid="landscape-confirm-button"
                >
                    {buttonText}
                </button>
            </div>
        </div>
    )
}
